export interface DataBlock {
  key: string;
  label: string;
  count: number;
  href: string;
  tagline: string;
  fields: string[];
}

export const DATA_BLOCKS: DataBlock[] = [
  {
    key: 'company-registry',
    label: 'Company Registry',
    count: 18,
    href: 'https://www.globaldatabase.com/kyb-verification',
    tagline: 'Who the entity legally is, straight from the register that issued its number.',
    fields: [
      'Global Database ID',
      'Company Legal Name',
      'Trading Name',
      'Registration Number',
      'VAT Number',
      'Year of Founding',
      'Company Status',
      'Legal Form',
      'Country',
      'Region',
      'Address Line 1',
      'Address Line 2',
      'City or State',
      'ZIP',
      'GEO Code Latitude',
      'GEO Code Longitude',
      'Office Locations',
      'Industry Classification Codes',
    ],
  },
  {
    key: 'officers-directors',
    label: 'Officers & Directors',
    count: 12,
    href: 'https://www.globaldatabase.com/kyb-verification',
    tagline: 'Who runs it, since when, and what else they are attached to.',
    fields: [
      'Officer ID',
      'Full Name',
      'Role',
      'Date of Birth',
      'Nationality',
      'Country of Residence',
      'Appointed On',
      'Resigned On',
      'Status',
      'Occupation',
      'Other Directorships',
      'PEP/Sanctions Flag',
    ],
  },
  {
    key: 'financial-data',
    label: 'Financial Data',
    count: 49,
    href: 'https://www.globaldatabase.com/company-financials',
    tagline: 'Accounts as filed, plus every margin and ratio derived from them.',
    fields: [
      'Latest Accounts Date Filed',
      'Ticker',
      'Turnover',
      'Reporting Period',
      'Working Capital',
      'Total Assets',
      'Intangible Assets',
      'Tangible Assets',
      'Fixed Assets',
      'Stock',
      'Trade Debtors',
      'Cash',
      'Current Assets',
      'Trade Creditors',
      'Current Liabilities',
      'Total Liabilities',
      'Net Assets',
      'Cost of Sales',
      'Gross Profit',
      'Operating Profit',
      'EBITDA',
      'Pre-Tax Profit',
      'Taxation',
      'Profit After Tax',
      'Retained Profits',
      'Sundry Reserves',
      'Shareholder Funds',
      'Capital Employed',
      'P&L Account Reserve',
      'Revaluation Reserve',
      'Consolidated A/cs',
      'Gross Margin',
      'Operating Profit Margin',
      'EBITDA Margin',
      'Pre-Tax Profit Margin',
      'Net Margin',
      'Return on Assets',
      'Return on Capital Employed',
      'Return on Equity',
      'Current Ratio',
      'Cash to Current Liabilities',
      'Cash to Total Assets',
      'Liquidity Ratio',
      'Gearing Liability',
      'Gearing Gross Debt',
      'Gearing Net Debt',
      'Debt to Capital',
      'Inventory Turnover Ratio',
      'Cash to Turnover Ratio',
    ],
  },
  {
    key: 'group-structure',
    label: 'Group Structure',
    count: 24,
    href: 'https://www.globaldatabase.com/corporate-linkage',
    tagline: 'Domestic ultimate, global ultimate and immediate parent — each one a resolvable entity.',
    fields: [
      'DomesticUltimateUniqueID',
      'DomesticUltimateBusinessName',
      'DomesticUltimateStreetAddress',
      'DomesticUltimateCityName',
      'DomesticUltimatePostalCode',
      'DomesticUltimateProvince',
      'DomesticUltimateCountry',
      'DomesticUltimateCountryCode',
      'GlobalUltimateUniqueID',
      'GlobalUltimateBusinessName',
      'GlobalUltimateStreetAddress',
      'GlobalUltimateCityName',
      'GlobalUltimatePostalCode',
      'GlobalUltimateProvince',
      'GlobalUltimateCountry',
      'GlobalUltimateCountryCode',
      'ParentUniqueID',
      'ParentBusinessName',
      'ParentStreetAddress',
      'ParentCityName',
      'ParentPostalCode',
      'ParentProvince',
      'ParentCountry',
      'ParentCountryCode',
    ],
  },
  {
    key: 'shareholders',
    label: 'Shareholders & UBO',
    count: 13,
    href: 'https://www.globaldatabase.com/ubo-discovery',
    tagline: 'The register of owners, with the UBO flag and the nature of control behind it.',
    fields: [
      'Shareholder ID',
      'Shareholder Name',
      'Shareholder Type',
      'Country of Registration/Residence',
      'Ownership Percentage',
      'Number of Shares',
      'Share Class',
      'Nominal Value',
      'UBO Flag',
      'PSC Nature of Control',
      'Date Notified',
      'Corporate Shareholder GDB ID',
      'PEP/Sanctions Flag',
    ],
  },
  {
    key: 'credit-risk',
    label: 'Credit Risk',
    count: 10,
    href: 'https://www.globaldatabase.com/business-credit-risk',
    tagline: 'Can they pay, and is there anything on file that says otherwise.',
    fields: [
      'Credit Score',
      'Credit Limit Recommendation',
      'Number of Court Judgments',
      'Number of Court Judgments Satisfied',
      'Number of Mortgages',
      'Average Invoice Value',
      'Invoices Available',
      'Paid Invoices',
      'Outstanding Invoices',
      'Customer Payment Experiences',
    ],
  },
  {
    key: 'firmographic',
    label: 'Firmographic Data',
    count: 18,
    href: 'https://www.globaldatabase.com/prospecting',
    tagline: 'How to reach the company, what it sells, and what is being written about it.',
    fields: [
      'Phone Number',
      'Fax',
      'Domain',
      'Email',
      'Estimated Employee Numbers',
      'Estimated Revenue',
      'Business Description',
      'Industry Tag',
      'LinkedIn Company Profile',
      'Facebook Company Profile',
      'Instagram Social Media Profile',
      'Logo',
      'Product Description',
      'Primary Revenue Model',
      'News Publication Date',
      'News Publisher',
      'Technologies Used',
      'Installed Stack',
    ],
  },
  {
    key: 'ma-activity',
    label: 'M&A Activity',
    count: 32,
    href: 'https://www.globaldatabase.com/ma-activity',
    tagline: 'Funding raised, acquisitions made, funds behind them and how they exited.',
    fields: [
      'Valuation',
      'Total Funding',
      'Funding Round Date',
      'Funding Round Type',
      'Funding Round Amount',
      'Funding Round Valuation',
      'Funding Round Lead Investor',
      'Acquisition Date',
      'Acquisition Target',
      'Acquisition Target Country',
      'Acquisition Target Sector',
      'Acquisition Deal Value',
      'Acquisition Type',
      'Acquisition Status',
      'Investor Name',
      'Investor Type',
      'Investor Country',
      'Fund Name',
      'Fund Vintage Year',
      'Fund Size',
      'Assets Under Management',
      'Fund Status',
      'Investment Date',
      'Portfolio Company',
      'Portfolio Company Sector',
      'Investment Round Type',
      'Investment Amount',
      'Exit Date',
      'Entity Sold',
      'Exit Buyer',
      'Exit Type',
      'Exit Transaction Value',
    ],
  },
  {
    key: 'key-executives',
    label: 'Sales & Marketing',
    count: 12,
    href: 'https://www.globaldatabase.com/enrichment',
    tagline: 'The named decision maker, their function, and how to reach them.',
    fields: [
      'First Name',
      'Second Name',
      'Job Title',
      'Department',
      'Seniority Level',
      'Work Email',
      'Work Phone Number',
      'Country of Residence',
      'LinkedIn Profile',
      'Work Experience',
      'Education',
      'Skills',
    ],
  },
];
